<template>
  <main class="page-main">
    <article class="page-article">
      <h1>Terms of Service</h1>
      <p class="meta">Last updated: April 26, 2026</p>
      <p>
        These Terms of Service (“Terms”) govern your use of the website operated by New Shivam Medicos at
        www.shivammedicos.in (the “Site”). By using the Site, you agree to these Terms.
      </p>

      <h2>1. Not medical advice</h2>
      <p>
        Content on the Site is for general information about our shop and services. It is
        <strong>not</strong> medical advice, diagnosis, or treatment. Always follow the advice of your
        doctor or qualified health professional. In an emergency, contact local emergency services.
      </p>

      <h2>2. Pharmacy services</h2>
      <p>
        Sale and supply of medicines follow applicable Indian laws and pharmacy practice. We may refuse
        service if a prescription is invalid, incomplete, or unsafe, or if required verification cannot be
        completed.
      </p>

      <h2>3. Orders and prescriptions</h2>
      <p>
        Prescription medicines are supplied in person at our shop (or as otherwise agreed by phone) in line
        with applicable law. This Site is for information only and does not accept prescription uploads or
        process online medicine orders. See our <RouterLink to="/privacy-policy">Privacy Policy</RouterLink>
        for how we handle personal data.
      </p>

      <h2>4. Acceptable use</h2>
      <p>
        You agree not to misuse the Site (for example: attempting to hack, overload, or scrape the Site in
        a way that harms operation, or uploading malware).
      </p>

      <h2>5. Intellectual property</h2>
      <p>
        Text, graphics, and layout on the Site are owned by New Shivam Medicos or used with permission. You
        may not copy or redistribute Site content for commercial use without our written consent.
      </p>

      <h2>6. Third-party services and ads</h2>
      <p>
        The Site may use analytics, maps, fonts, or advertising provided by third parties (including Google).
        Those services have their own terms and policies.
      </p>

      <h2>7. Disclaimer of warranties</h2>
      <p>
        The Site is provided “as is” without warranties of any kind, to the fullest extent permitted by law.
        We do not warrant that the Site will be uninterrupted or error-free.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, New Shivam Medicos and its staff shall not be liable for
        indirect or consequential damages arising from use of the Site. Nothing in these Terms excludes
        liability that cannot be excluded under applicable law.
      </p>

      <h2>9. Changes</h2>
      <p>
        We may update these Terms. The updated date will be revised above. Your continued use of the Site after
        changes constitutes acceptance.
      </p>

      <h2>10. Contact</h2>
      <p>
        For questions about these Terms: <a href="tel:+918876499294">+91 8876499294</a> or visit our shop at
        South Basistha Nagar, near Durga Mandir, Basistha, Guwahati, Assam.
      </p>
    </article>
  </main>
</template>

<script>
export default {
  name: "TermsOfService",
};
</script>
